var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import './index.scss';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProjectFilesApi from '~/api/project_files';
import SidebarSection from '~/components/sidebar_section';
import { useToast } from '~/components_to_be_packaged/toast/provider';
import { useUser } from '~/providers/user';
import AddToProjectForm from '~/routes/document_grid_view/action_menu/action_form/add_to_project';
import { useContentLibrary } from '../../providers/content_library_provider';
import { useRightPanel } from '../../providers/right_panel_provider';
import ButtonsContainer from './buttons_container';
import DocumentDownloadModal from './download_documents_modal';
import OldButtonsContainer from './old_buttons_container';
import SelectedDocument from './selected_document';
const SelectedDocumentsPanel = () => {
    const { search: locationSearch } = useLocation();
    const { useNewView } = useUser();
    const { selectedDocuments, toggleSelectedDocument } = useContentLibrary();
    const { downloadDocuments } = useRightPanel();
    const { showToast } = useToast();
    const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false);
    const [isAddToProjectModalOpen, setIsAddToProjectModalOpen] = useState(false);
    const searchParams = new URLSearchParams(locationSearch);
    const filtersString = searchParams.get('filters');
    let filters;
    if (filtersString) {
        filters = JSON.parse(filtersString);
    }
    const handleDeleteDocument = (documentId) => {
        toggleSelectedDocument({ id: documentId, name: 'unknown', txId: '', docType: '' });
    };
    const EmptyText = () => {
        if ((filters === null || filters === void 0 ? void 0 : filters.searchType) === 'clauses') {
            return React.createElement("div", { className: 'sidebar-section-empty', "data-testid": 'clause-search-empty-selected-documents' },
                React.createElement("span", null,
                    React.createElement("i", { className: 'fas fa-check-square' })),
                React.createElement("div", null, "Click a parent document(s) to start to compare."));
        }
        if (!filters || (filters === null || filters === void 0 ? void 0 : filters.searchType) === 'documents') {
            return React.createElement("div", { className: 'sidebar-section-empty', "data-testid": 'document-search-empty-selected-documents' },
                React.createElement("span", null,
                    React.createElement("i", { className: 'fas fa-check-square' })),
                React.createElement("div", null, "Check the box next to the document(s) you want to compare."));
        }
        return null;
    };
    const attachDocumentsToFolder = useCallback((files, projectId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, e_1, _b, _c;
        const response = [];
        try {
            for (var _d = true, _e = __asyncValues(files.map((file) => __awaiter(void 0, void 0, void 0, function* () {
                const data = yield ProjectFilesApi.post({
                    projectId,
                    fileId: file.id,
                }, false);
                response.push({ fileName: file.name, response: !!(data) });
            }))), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                _c = _f.value;
                _d = false;
                const res = _c;
                ;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return response;
    }), []);
    const deleteDocumentsFromFolder = useCallback((files) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, e_2, _b, _c;
        try {
            for (var _d = true, _e = __asyncValues(files.map((file) => __awaiter(void 0, void 0, void 0, function* () {
                const data = yield ProjectFilesApi.deleteById(file.id, false);
                if (!data) {
                    return false;
                }
            }))), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                _c = _f.value;
                _d = false;
                const res = _c;
                ;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return true;
    }), []);
    const deleteDocumentsFromProjectWorkspace = (files) => __awaiter(void 0, void 0, void 0, function* () {
        const isDeleted = yield deleteDocumentsFromFolder(files);
        showToast({
            description: isDeleted ? 'Comparison removed.' : 'Error in Comparison removal.',
        });
    });
    const addDocumentsToProjectFolder = (files, projectId) => __awaiter(void 0, void 0, void 0, function* () {
        if ((files === null || files === void 0 ? void 0 : files.length) > 0) {
            const response = yield attachDocumentsToFolder(files, projectId);
            const filesAdded = ((response === null || response === void 0 ? void 0 : response.length) > 0)
                ? response.filter(file => file.response).length
                : false;
            if (filesAdded) {
                const failedFiles = [...response.filter(file => !file.response)]
                    .map(file => file.fileName);
                const failedFilesText = (failedFiles === null || failedFiles === void 0 ? void 0 : failedFiles.length)
                    ? `. Documents failed (${failedFiles.join(',')})`
                    : '';
                showToast({
                    description: `Documents Added (${filesAdded})${failedFilesText}`,
                    undoCallback: () => deleteDocumentsFromProjectWorkspace(files),
                });
            }
            else {
                showToast({
                    description: 'Error...',
                });
            }
        }
    });
    const panelClassNames = classnames('selected-documents-panel-container', {
        half: !useNewView,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DocumentDownloadModal, { onHide: () => { setIsDownloadModalVisible(false); }, isVisible: isDownloadModalVisible, downloadCallback: (downloadType) => downloadDocuments(selectedDocuments, downloadType) }),
        React.createElement(AddToProjectForm, { onAttachComparison: addDocumentsToProjectFolder, isVisible: isAddToProjectModalOpen, setIsAddToProjectVisible: setIsAddToProjectModalOpen, documentComparisonId: selectedDocuments }),
        React.createElement(SidebarSection, { title: 'Selected Documents', className: panelClassNames, isActive: false, "data-testid": 'selected-documents-container' },
            React.createElement("div", { className: 'selected-wrapper', "data-testid": 'selected-documents-list' }, selectedDocuments.length > 0
                ? selectedDocuments.map((doc, index) => {
                    return React.createElement(SelectedDocument, { "data-testid": `selected-document-link-${index}`, key: doc.id, handleDeleteDocument: () => handleDeleteDocument(doc.id), doc: doc });
                })
                : React.createElement(EmptyText, null)),
            useNewView
                ? React.createElement(ButtonsContainer, null)
                : React.createElement(OldButtonsContainer, { setIsDownloadModalVisible: setIsDownloadModalVisible, setIsAddToProjectModalOpen: setIsAddToProjectModalOpen }))));
};
export default SelectedDocumentsPanel;
